var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcHeaderButton,{attrs:{"id":"talk-sidebar-trigger","title":_setup.ariaLabel,"aria-label":_setup.ariaLabel},on:{"click":function($event){return _setup.emit('click')}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(_setup.MessageText,{attrs:{"size":20}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }